export const ProgressBar = ({total1, total2}) => {
    return (
        <div style={{padding: "0 4rem 0 4rem", margin: "1rem 0 1rem 0"}}>
            <progress style={{progressColor: "red"}} className="progress is-danger" value={total1} max={total1 + total2} />
        </div>
    )
}